
<template>
<q-layout view="lhh LpR lff">
  <q-page-container>
    <q-page padding>
      <div class="row justify-between">
        <q-btn class="q-ma-xs q-pr-md justify-left" ripple dense flat color="black" to="/">
          <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
        </q-btn>
      </div>
      <div class='row d-flex full-width'>
        <menu-renderer :list-menu="values" />
      </div>
    </q-page>
  </q-page-container>
</q-layout>
</template>
<script>

import MenuRenderer from 'NafComponents/menu-renderer'
export default {
  name: 'HumanRes',
  components: {
    MenuRenderer
  },
  
  data () {
    return {
      values: [
        {
          name: 'Thông tin nhân sự',
          icon: 'account_circle',
          backgroundColor: 'green',
          ref: {
            path: '/human-resources/staff-information'
          }
        },
        {
          name: 'Thống kê nhân sự',
          icon: 'insert_chart',
          backgroundColor: 'blue',
          ref: {
            path: '/human-resources/staff-statistics'
          }
        }
      ]
    }
  }
}
</script>
